$( document ).ready( function() {

	/* - - - - - - - - - - - - - -       init marquee       - - - - - - - - - - - - - - - */
	function initMarquee() {
		const marqueeSettings = {
			duration: 17000,
			duplicated: true,
			startVisible: true,
			gap: $( window ).innerWidth() * 0.2
		};
		$( '.js-marquee' ).marquee( 'destroy' );
		$( '.js-marquee' ).marquee( marqueeSettings );
	}
	initMarquee();
	$( window ).on( 'resize', initMarquee );

	/* - - - - - - - - - - - - - -       init fancybox       - - - - - - - - - - - - - - - */
	function initFancybox() {
		$( '[data-fancybox]' ).fancybox({
			closeExisting: true,
			animationEffect: 'fade',
			touch: false,
			autoFocus: false,
			buttons: [
				'slideShow',
				'close'
			],
			smallBtn: true,
			btnTpl: {
				smallBtn:
					'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
					'<span class="icon icon-i-close"></span>' +
					'</button>'
			}
		});
	}
	initFancybox();

	/* - - - - - - - - - - - - - -       init fancybox video       - - - - - - - - - - - - - - - */
	$( '[data-fancybox-video]' ).fancybox({
		slideClass: 'modal-video',
		video: {
			tpl:
				'<video class="fancybox-video" autoplay playsinline muted loop="loop" controls controlsList="nodownload" poster="{{poster}}">' +
					'<source src="{{src}}" type="{{format}}" />' +
					'Sorry, your browser doesn\'t support embedded videos, <a href="{{src}}">download</a> and watch with your favorite video player!' +
				'</video>',
			format: '', // custom video format
			autoStart: true
		},
		buttons: [
			'slideShow',
			'close'
		],
		smallBtn: true,
		btnTpl: {
			smallBtn:
				'<button type="button" data-fancybox-close class="fancybox-button fancybox-close-small" title="{{CLOSE}}">' +
				'<span class="icon icon-i-close"></span>' +
				'</button>'
		},
		scrolling: 'hidden',
		helpers: {
			overlay: {
				locked: true
			}
		},
		beforeShow: function() {
			$( 'body' ).css({ 'overflow-y': 'hidden' });
		},
		afterClose: function() {
			$( 'body' ).css({ 'overflow-y': 'visible' });
		}
	});

	/* - - - - - - - - - - - - - -       scroll to       - - - - - - - - - - - - - - - */
	if ( window.location.hash !== '' ) {
		setTimeout( function () {
			const paddingTop = parseInt( $( window.location.hash ).css( 'padding-top' ) ) > 0 ? 0 : 40;
			$( 'html, body' ).animate({ scrollTop: $( window.location.hash ).offset().top - $( '.header-wrapper' ).innerHeight() - paddingTop + 'px' }, 500 );
		}, 300 );
	}
	$( document ).on( 'click', '.js-scroll-to', function( e ) {
		e.preventDefault();
		const link = $( this ).attr( 'href' ),
			lang = $( 'html' ).attr( 'lang' ) ? $( 'html' ).attr( 'lang' ).slice( 0, 2 ).toLowerCase() : '';
		if ( window.location.pathname === '' || window.location.pathname === '/' || window.location.pathname === '/en/' ) {
			const paddingTop = parseInt( $( link ).css( 'padding-top' ) ) > 0 ? 0 : 40;
			const posTop = $( link ).offset().top - $( '.header-wrapper' ).innerHeight() - paddingTop;
			$( 'html, body' ).animate({ scrollTop: posTop }, 500 );
		} else {
			if ( lang && lang !== 'de' ) {
				window.location.href = window.location.origin + '/' + lang + '/' + link;
			} else {
				window.location.href = window.location.origin + link;
			}
		}
	});

	/* - - - - - - - - - - - - - -       fixed header       - - - - - - - - - - - - - - - */
	function fixedHeader() {
		const top = $( window ).scrollTop(),
			$header = $( '.header' ),
			posTop = $header.offset().top + ( $header.innerHeight() - $( '.header-wrapper' ).innerHeight() ) / 2;
		if ( top > posTop ) {
			$header.addClass( 'fixed' );
		} else {
			$header.removeClass( 'fixed' );
		}
	}
	fixedHeader();
	$( window ).on( 'scroll resize', fixedHeader );

	/* - - - - - - - - - - - - - -       news play/pause short video       - - - - - - - - - - - - - - - */
	function autoplayNewsVideo() {
		$( '.news-box' ).each( function() {
			if ( $( this ).find( 'video' ).length ) {
				const video = $( this ).find( 'video' )[ 0 ];
				// video.play();
				setTimeout( function () {
					video.play();
				}, 500 );
			}
		});
	}
	autoplayNewsVideo();
	// $( document ).on( 'mouseenter', '.news-box', function() {
	// 	if ( $( this ).find( 'video' ).length ) {
	// 		$( this ).find( 'video' )[ 0 ].play();
	// 	}
	// });
	// $( document ).on( 'mouseleave', '.news-box', function() {
	// 	if ( $( this ).find( 'video' ).length ) {
	// 		$( this ).find( 'video' )[ 0 ].pause();
	// 	}
	// });

	/* - - - - - - - - - - - - - -       autoplay news short video       - - - - - - - - - - - - - - - */
	function playNewsVideo() {
		if ( window.matchMedia( '(hover: none)' ).matches ) {
			$( '.news-box video' ).each( function() {
				$( this )[ 0 ].play();
			});
		} else {
			$( '.news-box video' ).each( function() {
				$( this )[ 0 ].pause();
			});
		}
	}
	if ( $( '.news-box video' ).length ) {
		playNewsVideo();
		$( window ).on( 'resize', playNewsVideo );
	}

	/* - - - - - - - - - - - - - -       responsive change news long video       - - - - - - - - - - - - - - - */
	function changeNewsVideo() {
		$( '.news-box' ).each( function() {
			const $this = $( this ),
				href = $this.attr( 'href' ) ? $this.attr( 'href' ) : '',
				src = $this.attr( 'data-desktop-src' ) ? $this.attr( 'data-desktop-src' ) : '',
				mobileSrc = $this.attr( 'data-mobile-src' ) ? $this.attr( 'data-mobile-src' ) : '';
			if ( href && src && mobileSrc ) {
				if ( window.matchMedia( '(max-width: 767px)' ).matches ) {
					$this.attr( 'href', mobileSrc );
				} else {
					$this.attr( 'href', src );
				}
			}
		});
	}
	if ( $( '.news-box' ).length ) {
		changeNewsVideo();
		$( window ).on( 'resize', changeNewsVideo );
	}

	/* - - - - - - - - - - - - - -       news animate       - - - - - - - - - - - - - - - */
	function offsetNews() {
		const top = $( window ).scrollTop();
		$( '.js-news' ).each( function() {
			const $this = $( this ),
				posStart = parseInt( $this.offset().top - $( window ).innerHeight() ),
				posEnd = parseInt( $this.offset().top - $( window ).innerHeight() / 2 + $this.innerHeight() / 2 );
			let setY = $this.innerHeight() * $this.attr( 'data-offset' ),
				currentY = 0,
				currentOpacity = 0;
			if ( top < posStart ) {
				currentY = setY;
				currentOpacity = 0;
			} else if ( top > posStart && top < posEnd ) {
				currentY = ( posEnd - top ) / ( posEnd - posStart ) * setY;
				currentOpacity = 1 - ( posEnd - top ) / ( posEnd - posStart ) / 2;
			} else {
				currentY = 0;
				currentOpacity = 1;
			}
			$this.css({
				'transform': 'translateY(' + currentY + 'px)',
				'opacity': currentOpacity
			});
		});
	}
	offsetNews();
	$( window ).on( 'scroll resize', offsetNews );

	/* - - - - - - - - - - - - - -       set Collective       - - - - - - - - - - - - - - - */
	function setCollective() {
		const $big = $( '.collective-box.big' ),
			count = $( '.collective-box:not(.big)' ).length,
			bigH = $big.innerHeight(),
			bigW = $big.innerWidth(),
			dxdy = 0.2;
		$( '.collective-box:not(.big)' ).each( function() {
			const $this = $( this ),
				h = $this.innerHeight(),
				w = $this.innerWidth(),
				index = $this.index(),
				halfW = bigW / 2 + w / 2,
				halfH = bigH / 2 + h / 2;
			let offsetX = 0,
				offsetY = 0,
				signX = '',
				signY = '';
			if ( index === 1 || index === count ) {
				signY = '-';
			}
			if ( index > count / 2 ) {
				signX = '-';
			}
			if ( index === 2 || index === 5 ) {
				offsetX = halfW - dxdy;
			} else {
				offsetX = halfW / 2 - dxdy;
				offsetY = halfH / 2 * 1.5 - dxdy;
			}
			$this.css( 'transform', 'translate(' + signX + offsetX + 'px, ' + signY + offsetY + 'px)' );
		});
	}
	if ( $( '.collective-box' ).length ) {
		setCollective();
	}
	$( window ).on( 'resize', setCollective );

	/* - - - - - - - - - - - - - -       collective animate       - - - - - - - - - - - - - - - */
	function animateCollective() {
		const top = $( window ).scrollTop(),
			$collectiveList = $( '.collective-list' ),
			posStart = parseInt( $collectiveList.offset().top - $( window ).innerHeight() / 3 * 2 + $collectiveList.innerHeight() / 2 );
		if ( top > posStart ) {
			$collectiveList.find( '.collective-box:not(.big)' ).addClass( 'show' );
			setTimeout( function() {
				$collectiveList.find( '.collective-box:not(.big)' ).addClass( 'animated' );
			}, 500 );
		} else {
			$collectiveList.find( '.collective-box:not(.big)' ).removeClass( 'animated' ).removeClass( 'show' );
		}
	}
	if ( $( '.js-collective' ).length ) {
		animateCollective();
		$( window ).on( 'scroll resize', animateCollective );
	}

	/* - - - - - - - - - - - - - -       collective slider       - - - - - - - - - - - - - - - */
	$( '.js-collective-slider' ).slick({
		infinite: true,
		arrows: false,
		dots: false,
		lazyLoad: 'ondemand',
		slidesToShow: 1,
		slidesToScroll: 1,
		speed: 700,
		autoplay: true,
		autoplaySpeed: 1000,
		swipeToSlide: true
	});

	// $( document ).on( 'click', '.footer-link a', function( e ) {
	// 	e.preventDefault();
	// 	const src = $( this ).attr( 'href' );
	// 	$( '.overflow' ).addClass( 'show' );
	// 	setTimeout( function() {
	// 		window.location.replace( src );
	// 		$( '.overflow' ).removeClass( 'show' );
	// 	}, 500 );
	// });

	/* - - - - - - - - - - - - - -       init banner vimeo       - - - - - - - - - - - - - - - */
	$( '.js-vimeo' ).each( function () {
		const $this = $( this ),
			src = $this.attr( 'data-src' ) ? $this.attr( 'data-src' ) : '';
		let matches = /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/i.exec( src );
		if ( matches ) {
			const videoId = matches[2];
			$this.append( '<iframe class="vimeo" src="https://player.vimeo.com/video/' + videoId + '?background=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' )
		}
	});

	// $( '.js-vimeo' ).each( function () {
	// 	const $this = $( this ),
	// 		src = $this.attr( 'data-src' ) ? $this.attr( 'data-src' ) : '';
	// 	let matches = /^.+vimeo.com\/(.*\/)?([\d]+)(.*)?/i.exec( src );
	// 	if ( ~src.indexOf( 'player.vimeo.com' ) ) {
	// 		$this.append( '<iframe class="vimeo" src="' + src + '?background=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' )
	// 	} else {
	// 		if ( matches ) {
	// 			const videoId = matches[2];
	// 			$this.append( '<iframe class="vimeo" src="https://player.vimeo.com/video/' + videoId + '?background=1" frameborder="0" allow="autoplay; fullscreen" allowfullscreen></iframe>' )
	// 		}
	// 	}
	// 	// console.log(matches)
	// });
});
